// removed by extract-text-webpack-plugin
module.exports = {"slickslider":"_3flzJFUdrs4weRdA-cVtPN","itemWrap":"j7-iukR8honDAlpC3LXFr","next":"_1pdtaqgBivw3Jl5LR3kSEk","prev":"_1UNjyS4d3efnIQt0vqS2wQ","white":"_1RTsoa53VRwfju1Z855sHc","corrective":"_1bU7Gj4PSFY6nKxAiK_hOk"};


//////////////////
// WEBPACK FOOTER
// ./src/App/third-party/SlickCarousel/style.css
// module id = 365
// module chunks = 37